import { combineReducers } from '@reduxjs/toolkit';

import { activitiesTabSlice } from './activitiesTab';
import { auditTrailsTabSlice } from './auditTrailTab';
import { extraSlice } from './extra';
import { leadCoreInfoSlice } from './leadCoreInfo';
import { notesSlice } from './notesTab';
import { leadDetailTabSlice } from './tab';
import { tasksTabSlice } from './tasksTab';

export const leadDetailReducers = combineReducers({
  tab: leadDetailTabSlice.reducer,
  activitiesTab: activitiesTabSlice.reducer,
  tasksTab: tasksTabSlice.reducer,
  leadCoreInfo: leadCoreInfoSlice.reducer,
  notesTab: notesSlice.reducer,
  extra: extraSlice.reducer,
  auditTrailTab: auditTrailsTabSlice.reducer,
});
